import { useTextContent } from './useTextContent';
import { InlineStatus } from './InlineStatus';

interface Props {
  contentUrl: string;
}

// Raw text / source code preview. Rendered as a <pre> with preserved
// whitespace and soft-wrap disabled so long source lines scroll
// horizontally rather than breaking. Text nodes are set via React's
// normal children path, so no escape hatches.
export function TextView({ contentUrl }: Props) {
  const content = useTextContent(contentUrl);

  if (content.status === 'loading') return <InlineStatus label="Loading file…" />;
  if (content.status === 'error') return <InlineStatus label={`Error: ${content.message}`} error />;
  if (content.status === 'too-large')
    return <InlineStatus label="File is too large to render — use Download." error />;

  return (
    <pre className="mx-auto max-w-6xl overflow-auto whitespace-pre rounded-lg bg-panel p-4 font-mono text-sm text-panelFg">
      {content.text}
    </pre>
  );
}
